﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const defaultFunction = () => null;

export function UserAccess(
    {
        yes = defaultFunction,
        no = defaultFunction,
        perform
    }
) {
    const actions = useSelector(state => state.loggedInUser.actions);

    if (actions == null) {
        return <Fragment />;
    }

    return checkPermissions(perform, actions) ? yes() : no();
}

export function checkPermissions(action, actions) {

    if (action == null) {
        return true;
    }

    if (actions == null) {
        return false;
    }

    var allowedActions = actions.map((a) => {
        return a.toLowerCase()
    });

    //If the action is an array of actions, check we have one of the roles
    if (Array.isArray(action)) {
        var matchedActions = action.filter(a => allowedActions.includes(a.toLowerCase()));
        return matchedActions.length > 0;
    } else {
        return allowedActions.includes(action.toLowerCase());
    }
}

export const UserHasAccess = function (action) {
    const actions = useSelector(state => state.loggedInUser.actions);
    return checkPermissions(action, actions);
}

export const UserHasAccessActions = function (actionsToCheck, userActions) {
    return checkPermissions(actionsToCheck, userActions);
}

UserAccess.propTypes = {
    perform: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    yes: PropTypes.func,
    no: PropTypes.func
};
